<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre1"><br class="calibre2"/>
<br class="calibre2"/>
<br class="calibre2"/>
<br class="calibre2"/>
<br class="calibre2"/></p>
<h1 class="ct" id="heading_id_2">The Conflagration of Community: Fiction before and after Auschwitz</h1>
<p class="para" id="para1"><span class="bold">J. Hillis Miller</span></p>
<p class="calibre1"><br class="calibre2"/></p>
<p class="para" id="para2">The University of Chicago Press :: Chicago and London</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?c3176c10